<script lang="ts" setup>
import { onBeforeMount, onMounted, ref } from 'vue';

const props = defineProps({
  src: {
    type: String,
    required: true,
  },
  alt: {
    type: String,
    required: false,
    default: '',
  },
  isStatic: {
    type: Boolean,
    default: false,
  },
});

const imageRef = ref<HTMLImageElement | null>(null);
const imageError = ref(false);
const isLoading = ref(true);
const isBrowser = ref(false);

const handleImageError = () => {
  imageError.value = true;
  isLoading.value = false;
};

const handleImageLoad = () => {
  isLoading.value = false;
};

// Check if we're in browser environment before mounting
onBeforeMount(() => {
  isBrowser.value = typeof window !== 'undefined';
});

onMounted(() => {
  // Only proceed with image loading in browser environment
  if (!isBrowser.value) return;
  if (!imageRef.value) return;

  const imgElement = imageRef.value;
  imgElement.onload = handleImageLoad;
  imgElement.onerror = handleImageError;

  // Use setTimeout to ensure this happens after hydration
  setTimeout(() => {
    imgElement.src = props.src;
  }, 0);
});
</script>

<script lang="ts">
export default {
  name: 'SeImg',
};
</script>
<template>
  <div class="relative">
    <img
      ref="imageRef"
      :alt="props.alt"
      class="w-full h-full object-cover"
      :class="{ 'opacity-0': isLoading || imageError }"
    />
  </div>
</template>
